import { render } from "./TpImport.vue?vue&type=template&id=1e101ce1&scoped=true"
import script from "./TpImport.vue?vue&type=script&lang=js"
export * from "./TpImport.vue?vue&type=script&lang=js"

import "./TpImport.vue?vue&type=style&index=0&id=1e101ce1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e101ce1"]])

export default __exports__